/* va-pack-fiche.js - 18 septembre 2026
 *
 * Sur la page Commander, un clic sur une carte de PACK mene a la fiche produit
 * (/products/<handle>) au lieu douvrir directement le configurateur. Le client
 * lit la description, puis le bouton Commander ce pack de la fiche le renvoie
 * ici avec ?pack=<handle>, et va-pack-lien.js ouvre le configurateur.
 *
 * Les vetements ordinaires ne sont pas touches : eux ouvrent le configurateur
 * au premier clic, comme avant.
 *
 * Aucune modification de lapplication. On ecoute le clic en phase de CAPTURE,
 * donc avant React, et on larrete seulement si on a formellement identifie une
 * carte de pack. Si la structure de lapp change, la condition ne matche plus et
 * la page revient au comportement davant : rien ne casse.
 *
 * Retour arriere : retirer la balise script dans templates/page.commander.liquid.
 */
(function () {
  "use strict";

  function packs() {
    var t = window.__VA_PRODUCTS__;
    if (!Array.isArray(t)) return [];
    return t.filter(function (p) {
      return p && p.category === "pack" && (p.shopHandle || p.id);
    });
  }

  /* Le bouton voir le dos / voir le devant vit a linterieur de la carte et a son
     propre role : on ne doit jamais lintercepter, sinon on empeche le client de
     retourner le vetement. */
  function estBasculeVue(n, carte) {
    while (n && n !== carte) {
      var s = (n.textContent || "").trim().toLowerCase();
      if (s.length < 26 && (s.indexOf("voir le dos") === 0 || s.indexOf("voir le devant") === 0)) return true;
      n = n.parentElement;
    }
    return false;
  }

  function surClic(e) {
    /* 1. Un clic simule (va-pack-lien.js appelle .click()) nest pas de confiance :
          si on linterceptait, la fiche produit et la page Commander se
          renverraient la balle a linfini. */
    if (!e.isTrusted) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    /* 2. On arrive deja depuis une fiche produit : laisser passer. */
    if (window.location.search.indexOf("pack=") > -1) return;

    /* 3. Le configurateur est ouvert : on ne touche a rien de ce qui est dedans. */
    if (document.querySelector("[role='dialog']")) return;

    var btn = e.target && e.target.closest ? e.target.closest("button") : null;
    if (!btn) return;

    var txt = btn.textContent || "";
    if (txt.indexOf("Personnaliser") < 0) return;

    var liste = packs();
    var trouve = null;
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].name && txt.indexOf(liste[i].name) > -1) { trouve = liste[i]; break; }
    }
    if (!trouve) return;

    if (estBasculeVue(e.target, btn)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    window.location.href = "/products/" + (trouve.shopHandle || trouve.id);
  }

  document.addEventListener("click", surClic, true);
})();
